<script>
import {defineComponent} from 'vue'
import {Link} from "@inertiajs/vue3";
import IconLogo from "@js/components/Icons/IconLogo.vue";
import ModalSelect from "@js/components/Input/ModalSelect.vue";
import IconChevronDown from "@js/components/Icons/IconChevronDown.vue";
import IconDesigner from "@js/components/Icons/IconDesigner.vue";
import IconBuilder from "@js/components/Icons/IconBuilder.vue";
import IconArchitecture from "@js/components/Icons/IconArchitecture.vue";

export default defineComponent({
    name: "B2BTopBar",
    components: {
        IconArchitecture,
        IconBuilder,
        IconDesigner,
        IconChevronDown,
        ModalSelect,
        IconLogo,
        Link,
    }
})
</script>

<template>
    <div class="bg-black text-white">
        <div class="container mt-[16px] flex items-center justify-between">
            <Link :href="route('home')" aria-label="Лого">
                <IconLogo class="h-[44px] min-w-[134px] object-contain"
                          text_color="#fff" icon_color="#fff"/>
            </Link>
            <ModalSelect :buttonClass="'bg-transparent font-normal'">
                <template #button>
                    <div
                        class="flex items-center gap-1 group-hover:text-navHoverColor transition border-2 border-baseColor rounded-lg px-5 py-2.5">
                        <div>
                            B2B Услуги
                        </div>
                        <IconChevronDown
                            class="w-4 h-4 text-gray-600 group-hover:text-navHoverColor transition"/>
                    </div>
                </template>
                <template #menu>
                    <ul class=" text-sm text-gray-700">
                        <Link :href="route('B2BForDesigners')">
                            <li class="block px-4 py-4 font-medium cursor-pointer md:hover:bg-gray-100">
                                <div
                                    class="flex items-center gap-2 text-sm font-bold text-nowrap leading-tight mt-0.5">
                                    <IconDesigner class="w-5 h-5"/>
                                    Дизайнерам
                                </div>
                            </li>
                        </Link>
                        <Link :href="route('B2BForBuilders')">
                            <li class="block px-4 py-4 font-medium cursor-pointer md:hover:bg-gray-100">
                                <div
                                    class="flex items-center gap-2 text-sm font-bold text-nowrap leading-tight mt-0.5">
                                    <IconBuilder class="w-5 h-5"/>
                                    Строителям
                                </div>
                            </li>
                        </Link>
                        <Link :href="route('B2BForArchitects')">
                            <li class="block px-4 py-4 font-medium cursor-pointer md:hover:bg-gray-100">
                                <div
                                    class="flex items-center gap-2 text-sm font-bold text-nowrap leading-tight mt-0.5">
                                    <IconArchitecture class="w-5 h-5"/>
                                    Архитекторам
                                </div>
                            </li>
                        </Link>
                    </ul>
                </template>
            </ModalSelect>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
